import ControlService from "@/services/control.service"
import { utils } from "../helpers"
// import store from ".."
const initialState = {
  modules: {},
  roles: [],
  permissions: [],
  metrics: [],
  primary_menu: [],
  actions_menu: [],
  is_enterprise_edition: true,
  is_portfolio_activated: false,
  is_company_profile_activated: false,

  is_prospecting_activated: false,
  is_prospecting_prospect_activated: false,
  is_prospecting_my_lists_activated: false,
  is_prospecting_suggested_lists_activated: false,
  is_prospecting_growth_matrix_activated: false
}

export const control = {
  namespaced: true,
  state: initialState,
  actions: {
    getMenus({ dispatch, commit }) {
      return ControlService.getMenus().then(
        (response) => {
          commit("setModules", response.data.modules)
          let primary_menu = response.data.modules.filter((m) => m.entry_point == "primary_menu")
          let actions_menu = response.data.modules.filter((m) => m.entry_point == "actions_menu")
          commit(
            "setPrimaryMenu",
            primary_menu.map((m) => {
              return {
                modules: response.data.modules.find((n) => n.id == m.module),
                ...m
              }
            })
          )
          commit(
            "setActionsMenu",
            actions_menu.map((m) => {
              return {
                modules: response.data.modules.find((n) => n.id == m.module),
                ...m
              }
            })
          )
          return Promise.resolve(response.data)
        },
        (error) => {
          if (error?.response?.status == 401) {
            dispatch("forceLogout", {}, { root: true })
          }
          return Promise.reject(error)
        }
      )
    },
    getRoles({ commit, dispatch }) {
      dispatch("getPermissions")
      return ControlService.getRoles().then(
        (response) => {
          commit("setRoles", response.data.results)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    getPermissions({ commit }) {
      return ControlService.getPermissions().then(
        (response) => {
          commit("setPermissions", response.data.results)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    updateRole({ dispatch, commit, state }, { id, data }) {
      return ControlService.updateRole(id, data).then(
        (response) => {
          let roles = utils.replaceOrAddItem(state.roles, response.data)
          commit("setRoles", roles)
          return Promise.resolve(roles)
        },
        (error) => {
          if (error?.response?.status == 401) {
            dispatch("forceLogout", {}, { root: true })
          }
          return Promise.reject(error)
        }
      )
    },
    setPlatformOptions({ commit }, data) {
      return ControlService.setPlatformOptions(data).then(
        (response) => {
          commit("setPlatformOptions", response.data)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    addRole({ commit, state }, data) {
      return ControlService.addRole(data).then(
        (response) => {
          let roles = utils.replaceOrAddItem(state.roles, response.data)
          commit("setRoles", roles)
          return Promise.resolve(roles)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    activateModule: {
      root: true,
      handler({ commit }, { name }) {
        commit("activateModule", name)
      }
    },
    deactivateModule: {
      root: true,
      handler({ commit }, { name }) {
        commit("deactivateModule", name)
      }
    },
    refreshMetricsList: {
      root: true,
      handler({ dispatch }) {
        dispatch("data/getMetrics", null, { root: true })
      }
    }
  },

  mutations: {
    stateReset(state) {
      Object.assign(state, initialState)
    },
    setPrimaryMenu(state, primary_menu) {
      state.primary_menu = primary_menu
    },
    setActionsMenu(state, actions_menu) {
      state.actions_menu = actions_menu
    },
    updatePrimaryMenuOrder(state, new_order) {
      state.primary_menu = new_order
    },
    setModules(state, modules) {
      state.modules = modules
      state.nested_modules = state.modules.filter((m) => m.entry_point != "parent")
      state.nested_modules.map((m) => {
        m["children"] = state.modules.filter((n) => n.parent == m.id)
        return m
      })
      state.primary_menu = state.modules.filter((m) => m.entry_point == "primary_menu")
      state.actions_menu = state.modules.filter((m) => m.entry_point == "actions_menu")
      // nest the menus
      state.primary_menu = state.primary_menu.map((m) => {
        m["children"] = state.modules.filter((n) => n.parent == m.id)
        return m
      })
      state.actions_menu = state.actions_menu.map((m) => {
        m["children"] = state.modules.filter((n) => n.parent == m.id)
        return m
      })
      state.primary_menu = state.primary_menu.filter((m) => m.entry_point != "parent")
      state.actions_menu = state.actions_menu.filter((m) => m.entry_point != "parent")
    },
    setRoles(state, roles) {
      state.roles = roles
    },
    setPermissions(state, permissions) {
      state.permissions = permissions
    },
    updateFlag(state, { flag, status }) {
      state[flag] = status
    },

    setIsEnterpriseEdition(state, is_enterprise_edition) {
      state.is_enterprise_edition = is_enterprise_edition
    },
    activateModule(state, name) {
      state.primary_menu = state.primary_menu.map((m) => {
        if (m.reference_name == name || m.name.toLowerCase() == name.toLowerCase()) {
          m.is_activated = true
          m.is_visible = true
        }
        return m
      })
      state.actions_menu = state.actions_menu.map((m) => {
        if (m.reference_name == name) {
          m.is_activated = true
          m.is_visible = true
        }
        return m
      })
    },
    deactivateModule(state, name) {
      state.primary_menu = state.primary_menu.map((m) => {
        if (m.reference_name == name || m.name.toLowerCase() == name.toLowerCase()) {
          m.is_activated = false
          m.is_visible = false
        }
        return m
      })
      state.actions_menu = state.actions_menu.map((m) => {
        if (m.reference_name == name) {
          m.is_activated = false
          m.is_visible = false
        }
        return m
      })
    }
  }
}
